import "../../../../../css/CashflowModeller2/Dashboard/Pagination.css";
import { ReactComponent as ArrowLeft } from "../../../../../assets/icons/Arrow Left.svg";
import { ReactComponent as ArrowRight } from "../../../../../assets/icons/Arrow Right.svg";

/**
 * Pagination component for navigating through pages of data.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {number} props.currentPage - The currently active page number.
 * @param {number} props.totalPages - The total number of available pages.
 * @param {function} props.onPageChange - Callback function invoked with the new page number when a page is selected.
 * @param {number} props.itemsPerPage - The number of items displayed per page.
 * @param {function} props.setItemsPerPage - Function to update the number of items per page.
 * @returns {JSX.Element} The rendered pagination controls.
 */
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const pageNumbers = [];
  const maxButtons = 5;
  let start = Math.max(1, currentPage - 2);
  let end = Math.min(totalPages, start + maxButtons - 1);
  if (end - start < maxButtons - 1) {
    start = Math.max(1, end - maxButtons + 1);
  }

  for (let i = start; i <= end; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="Pagination-Container">
      <ArrowLeft onClick={() => onPageChange(Math.max(currentPage - 1, 1))} />

      {pageNumbers.map((num) => (
        <button
          key={num}
          className={`pagination-btn ${currentPage === num ? "active" : ""}`}
          onClick={() => onPageChange(num)}
        >
          <div className="Content-SemiBold">{num}</div>
        </button>
      ))}

      <ArrowRight
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
      />
    </div>
  );
};

export default Pagination;
